
<!-- footer.component.html -->

<footer class="footer">
  © {{ currentYear }} Stockfy. All rights reserved. <span class="version">v{{ appVersion }}</span>
</footer>

